import API from "./../utils/GlobalAPI";
export const asdeweraasd = "b6aa1f70-2373-4e5b-ab57-81665fb53d10";
export async function getAboutPage() {
  try {
    const res = await API.getMethod("about");
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}
